import { NavLink } from 'react-router-dom';
import c from 'classnames';

import { LinkButton, ButtonVariants } from 'components';

import { Icon, IconName, Typography } from '@repo/ui';
import styles from './Sidebar.module.scss';

const SidebarItem = ({
  to,
  icon,
  label,
  onClick,
  state,
  external,
  customClassName,
}: {
  to: string;
  icon: IconName;
  label: string;
  onClick?: () => void;
  state?: { tinyAccountId?: string; kitId?: string; from?: string };
  external?: boolean;
  customClassName?: string;
}) => {
  if (external) {
    return (
      <LinkButton
        label={label}
        href={to}
        external
        variant={ButtonVariants.WRAPPER}
        linkClassName={c(
          styles.sidebarItem,
          'align-items-center',
          customClassName,
        )}
      >
        <Icon name={icon} />
        <Typography variant='body-s'>{label}</Typography>
      </LinkButton>
    );
  }

  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        c(
          styles.sidebarItem,
          'align-items-center',
          isActive && styles.active,
          customClassName,
        )
      }
      onClick={onClick}
      state={{ ...state }}
    >
      {({ isActive }) => (
        <>
          <Icon name={isActive ? ((icon + 'Filled') as IconName) : icon} />
          <Typography variant='body-s'>{label}</Typography>
        </>
      )}
    </NavLink>
  );
};

export default SidebarItem;
